import { useEffect, useState } from "react";
import makeAnimated from "react-select/animated";
import AsyncSelect from "react-select/async";
import useGetHook from "../../../customHooks/useGetHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useController, useWatch } from "react-hook-form";
import { useDebounce } from "../../../customHooks/useDebounceHook";

const animatedComponents = makeAnimated();

const MultipleSelectField = (props: any) => {
  const {
    watch,
    setValue,
    label,
    queryKey,
    url,
    errors,
    control,
    name,
    params,
    ...otherProps
  } = props;

  const limit = 10;
  const [query, setQuery] = useState("");
  const debounceSearch = useDebounce(query);

  const { data: serverData } = useGetHook({
    queryKey: [queryKey, `${queryKey}-${limit}-${debounceSearch}`],
    url: url,
    params: {
      limit: limit,
      offset: 0,
      search: debounceSearch,
      ...params,
    },
  });

  const {
    field: { value = [], onChange },
  } = useController({
    name,
    control,
    defaultValue: [],
  });

  const handleChange = (value: any) => {
    onChange(value);
  };

  const loadOptions = (
    inputValue: string,
    callback: (options: any) => void
  ) => {
    setQuery(inputValue?.length === 1 ? "" : inputValue);
    setTimeout(() => {
      callback(
        serverData?.results?.map((item: any) => ({
          label: item.name,
          value: item.id,
        })) ?? []
      );
    }, 1000);
  };

  return (
    <div className={tw`mt-4`}>
      <label htmlFor={name}>{label}</label>
      <AsyncSelect
        value={value}
        loadOptions={loadOptions}
        components={animatedComponents}
        closeMenuOnSelect={false}
        onChange={handleChange}
        isMulti
        styles={{
          control(base, props) {
            return {
              ...base,
              backgroundColor: "#EEF5F4",
              border: props.menuIsOpen || props.isFocused ? "none" : "none",
              outline:
                props.menuIsOpen || props.isFocused
                  ? "none !important"
                  : "none  !important",
              cursor: "text",
            };
          },
        }}
        defaultOptions={
          serverData?.results?.map((item: any) => ({
            label: item.name,
            value: item.id,
          })) ?? []
        }
      />
      {errors && (
        <p className={tw`text-red-500 text-xs my-1`}>{errors.message}</p>
      )}
    </div>
  );
};

export default MultipleSelectField;
